import {defineStore} from 'pinia'
import {FilterMatchMode} from "primevue/api";
import _ from "lodash";
import {useDevicesStore} from "@/stores/devices.js";
import {getFirstPage, onFilter, onPage, onRowsUpdate, onSearch, onSort} from "@/stores/_helpers.js";

// TODO: Finish off logic on this store, and apply it to the Device Dashboard Widgets...
export const useDevicesDashboardPageStore = defineStore('devicesDashboardPage', {
    state: () => ({
        // counts
        devices_count: {
            data: undefined,
            loading: true,
        },
        up_to_date_devices_count: {
            data: undefined,
            loading: true,
        },

        // charts
        devices_by_device_type: {
            data: undefined,
            loading: true,
        },
        devices_by_update_status: {
            data: undefined,
            loading: true,
        },
        count_over_time: {
            data: undefined,
            loading: true,
        },
        update_count_over_time: {
            data: undefined,
            loading: true,
        },

        // lists
        recently_updated_devices: {
            data: undefined,
            filters: null,
            totalRecords: 0,
            loading: true,
            params: {
                per_page: 10,
                page: 1,
                include: [],
                filter: {
                    search: undefined
                }
            },
        },
        needing_an_update: {
            data: undefined,
            filters: null,
            totalRecords: 0,
            loading: true,
            params: {
                per_page: 10,
                page: 1,
                include: [],
                filter: {
                    search: undefined
                }
            },
        },

        pages: [
            10,
            20,
            50,
            100,
        ]
    }),
    getters: {
        getDevicesTotalCount: (state) => {
            return state.devices_count?.data;
        },
        getDevicesTotalCountLoading: (state) => {
            return state.devices_count?.loading;
        },

        getUpToDateDevicesCount: (state) => {
            return state.up_to_date_devices_count?.data;
        },
        getUpToDateDevicesCountLoading: (state) => {
            return state.up_to_date_devices_count?.loading;
        },

        getDevicesByDeviceType: (state) => {
            return state.devices_by_device_type?.data;
        },
        getDevicesByDeviceTypeLoading: (state) => {
            return state.devices_by_device_type?.loading;
        },

        getDevicesByUpdateStatus: (state) => {
            return state.devices_by_update_status?.data;
        },
        getDevicesByUpdateStatusLoading: (state) => {
            return state.devices_by_update_status?.loading;
        },

        getDeviceCountOverTime: (state) => {
            return state.count_over_time?.data;
        },
        getDeviceCountOverTimeLoading: (state) => {
            return state.count_over_time?.loading;
        },

        getDeviceUpdateCountOverTime: (state) => {
            return state.update_count_over_time?.data;
        },
        getDeviceUpdateCountOverTimeLoading: (state) => {
            return state.update_count_over_time?.loading;
        },

        getDevicesRecentlyUpdated: (state) => {
            return state.recently_updated_devices?.data;
        },
        getDevicesRecentlyUpdatedLoading: (state) => {
            return state.recently_updated_devices?.loading;
        },

        getDevicesNeedingAnUpdate: (state) => {
            return state.needing_an_update?.data;
        },
        getDevicesNeedingAnUpdateLoading: (state) => {
            return state.needing_an_update?.loading;
        },
        getDevicesNeedingAnUpdateCount: (state) => {
            return state.needing_an_update?.totalRecords;
        },
        getDevicesNeedingAnUpdateCountLoading: (state) => {
            return state.needing_an_update?.loading;
        },

    },
    actions: {
        getFirstPage: (key = 'recently_updated_devices') => {
            return this?.[key] ? getFirstPage(this[key].params) : null;
        },
        onPage($event, key = 'recently_updated_devices') {
            onPage($event, this[key].params);
            this.fetchDevicesNeedingAnUpdate();
        },

        async fetchDevicesTotalCount(params = {}, forceRefresh = true) {
            if (forceRefresh)
                this.devices_count.data = undefined;

            if (this.devices_count.data === undefined){
                this.devices_count.loading = true;
                try {
                    const response = await axios.get('dashboard/devices/count', params);
                    this.devices_count.data = response.data;
                }
                catch (e) {
                    console.log(e);
                    this.devices_count.data = undefined;
                    throw (e);
                }
                finally {
                    this.devices_count.loading = false
                }
            }

            return this.devices_count.data;
        },
        async fetchUpToDateDevicesCount(params = {}, forceRefresh = true) {
            if (forceRefresh)
                this.up_to_date_devices_count.data = undefined;

            if (this.up_to_date_devices_count.data === undefined){
                this.up_to_date_devices_count.loading = true;
                try {
                    const response = await axios.get('dashboard/devices/up-to-date-devices-count', params);
                    this.up_to_date_devices_count.data = response.data;
                }
                catch (e) {
                    console.log(e);
                    this.up_to_date_devices_count.data = undefined;
                    throw (e);
                }
                finally {
                    this.up_to_date_devices_count.loading = false
                }
            }

            return this.up_to_date_devices_count.data;
        },
        async fetchDevicesByDeviceType(params = {}, forceRefresh = true) {
            if (forceRefresh){
                this.devices_by_device_type.data = undefined;
            }

            if (this.devices_by_device_type.data === undefined){
                this.devices_by_device_type.loading = true;
                try {
                    const response = await axios.get('dashboard/devices/by-device-type', params);
                    this.devices_by_device_type.data = response.data;
                }
                catch (e) {
                    console.log(e);
                    this.devices_by_device_type.data = undefined;
                    throw (e);
                }
                finally {
                    this.devices_by_device_type.loading = false
                }
            }

            return this.devices_by_device_type.data;
        },
        async fetchDevicesByUpdateStatus(params = {}, forceRefresh = true) {
            if (forceRefresh){
                this.devices_by_update_status.data = undefined;
            }

            if (this.devices_by_update_status.data === undefined){
                this.devices_by_update_status.loading = true;
                try {
                    const response = await axios.get('dashboard/devices/by-update-status', params);
                    this.devices_by_update_status.data = response.data;
                }
                catch (e) {
                    console.log(e);
                    this.devices_by_update_status.data = undefined;
                    throw (e);
                }
                finally {
                    this.devices_by_update_status.loading = false
                }
            }

            return this.devices_by_update_status.data;
        },
        async fetchDeviceCountOverTime(params = {}, forceRefresh = true) {
            if (forceRefresh)
                this.count_over_time.data = undefined;

            if (this.count_over_time.data === undefined){
                this.count_over_time.loading = true;
                try {
                    const response = await axios.get('dashboard/devices/count-over-time', params);
                    this.count_over_time.data = response.data;
                }
                catch (e) {
                    console.log(e);
                    this.count_over_time.data = undefined;
                    throw (e);
                }
                finally {
                    this.count_over_time.loading = false
                }
            }

            return this.count_over_time.data;
        },
        async fetchDeviceUpdateCountOverTime(params = {}, forceRefresh = true) {
            if (forceRefresh)
                this.update_count_over_time.data = undefined;

            if (this.update_count_over_time.data === undefined){
                this.update_count_over_time.loading = true;
                try {
                    const response = await axios.get('dashboard/devices/update-count-over-time', params);
                    this.update_count_over_time.data = response.data;
                }
                catch (e) {
                    console.log(e);
                    this.update_count_over_time.data = undefined;
                    throw (e);
                }
                finally {
                    this.update_count_over_time.loading = false
                }
            }

            return this.update_count_over_time.data;
        },

        async fetchDevicesRecentlyUpdated(params = {}, forceRefresh = true) {
            if (forceRefresh){
                this.recently_updated_devices.data = undefined;
                this.recently_updated_devices.totalRecords = undefined;
            }

            if (this.recently_updated_devices.data === undefined){
                this.recently_updated_devices.loading = true;
                try {
                    const response = await axios.get('dashboard/devices/recently-updated', {
                        params: this.recently_updated_devices.params
                    });
                    this.recently_updated_devices.data = response.data.data;
                    this.recently_updated_devices.totalRecords = response.data.total;
                }
                catch (e) {
                    console.log(e);
                    this.recently_updated_devices.data = undefined;
                    this.recently_updated_devices.totalRecords = undefined;
                    throw (e);
                }
                finally {
                    this.recently_updated_devices.loading = false
                }
            }

            return this.recently_updated_devices.data;
        },
        async fetchDevicesNeedingAnUpdate(params = {}, forceRefresh = true) {
            if (forceRefresh){
                this.needing_an_update.data = undefined;
                this.needing_an_update.totalRecords = undefined;
            }

            if (this.needing_an_update.data === undefined){
                this.needing_an_update.loading = true;
                try {
                    const response = await axios.get('dashboard/devices/needing-an-update', {
                        params: this.needing_an_update.params
                    });
                    this.needing_an_update.data = response.data.data;
                    this.needing_an_update.totalRecords = response.data.total;
                }
                catch (e) {
                    console.log(e);
                    this.needing_an_update.data = undefined;
                    this.needing_an_update.totalRecords = undefined;
                    throw (e);
                }
                finally {
                    this.needing_an_update.loading = false
                }
            }

            return this.needing_an_update.data;
        },
    },
});
